import {
    createSelector,
} from '@reduxjs/toolkit';

import { PER_PAGE_COUNT } from '~scenes/madeforyou/constants';

const madeForYouData = (state) => state.mfyData;

export const selectActiveTab = createSelector(
    madeForYouData,
    (data) => data.activeTab
);

export const selectIsMadeForYouWidget = createSelector(
    madeForYouData,
    (data) => data.isMadeForYouWidget
);

export const selectTabList = createSelector(
    madeForYouData,
    (data) => data.tabList
);

export const selectTabIsLoading = createSelector(
    [ madeForYouData, selectActiveTab ],
    (data, activeTab) => data.isLoading[activeTab]
);

export const selectCurrentPage = createSelector(
    madeForYouData,
    (data) => data.currentPage
);

export const selectBetCards = createSelector(
    madeForYouData,
    (data) => data.betCards
);

export const selectBetCardsByPage = createSelector(
    [selectBetCards, selectCurrentPage],
    (betCards, page) => betCards.slice((page - 1) * PER_PAGE_COUNT, page * PER_PAGE_COUNT)
);

export const selectVisibleBetCardSelectionIds = createSelector(
    [selectBetCardsByPage],
    (betCards) => betCards.reduce((acc, betcard) => [...acc, betcard.betcard_id], [])
);

export const selectCommonDataEvents = (state) => state.commonData;
